import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const PHOTOS_PER_PAGE = 15;
const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const allPortraitPhotos = [
  // Page 1
  { id: 1, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/757c455e03115d8e9ca14e2a347fd90f.jpeg', title: '静寂の中で' },
  { id: 2, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/c292f37ce7811b5f4b54f7a15e8b2747.jpeg', title: '光の中の表情' },
  { id: 3, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/86e5fb2f58118a4b741aa1aadf8e2dfd.jpeg', title: '着物の佇まい' },
  { id: 4, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/bcc6f159cecf2dfff2f7ff363c12d6ac.jpeg', title: '素顔の美しさ' },
  { id: 5, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/92eddd755efcb91e6d4cd637cc0c40ce.jpeg', title: '青春の一瞬' },
  { id: 6, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/16c82ec85ce9bfa2d88c004db29f0072.jpeg', title: '年輪の顔' },
  { id: 7, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/76aa1c2df7114ec36a848d5f0dfbf26b.jpeg', title: '都市の中で' },
  { id: 8, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/b0f3143105a855146700edb53afad658.jpeg', title: '竹林の静寂' },
  { id: 9, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/74d8c314f0f245b442e92610dd2aaf2a.jpeg', title: '思索の時間' },
  { id: 10, url: 'https://public.readdy.ai/ai/img_res/e046ef790046d90d301d7fc1dbdd6e0b.jpg', title: '海風の中で' },
  { id: 11, url: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20portrait%2C%20autumn%20leaves%20background%2C%20red%20and%20orange%20tones%2C%20contemplative%20expression%2C%20fine%20art%20photography%2C%20soft%20bokeh%2C%20seasonal%20beauty&width=800&height=1000&seq=portrait011&orientation=portrait', title: '紅葉の季節' },
  { id: 12, url: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20portrait%2C%20studio%20lighting%2C%20dramatic%20shadows%2C%20black%20background%2C%20high%20contrast%2C%20artistic%20photography%2C%20strong%20expression%2C%20fashion%20style&width=800&height=1000&seq=portrait012&orientation=portrait', title: 'スタジオポートレート' },
  { id: 13, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/21213dbe71a3e55fe9bfa1b0650da6f9.jpeg', title: '朝の庭で' },
  { id: 14, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/ddf67b4d44b9b6cb3186d704e62a8441.jpeg', title: '山の男' },
  { id: 15, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/54b1989494ed864432a94f9704a50a9c.jpeg', title: '雨の日の詩' },
  // Page 2
  { id: 16, url: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20portrait%2C%20sunset%20golden%20hour%2C%20silhouette%2C%20warm%20orange%20tones%2C%20romantic%20mood%2C%20outdoor%20photography%2C%20dreamy%20atmosphere&width=800&height=1000&seq=portrait016&orientation=portrait', title: '黄金の夕暮れ' },
  { id: 17, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/e1376862c5198c8af47c8a007ff37f06.jpeg', title: '茶の湯' },
  { id: 18, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/c80d9e070712840c94ffbe1687b3f228.jpeg', title: '街の記憶' },
  { id: 19, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/b805425c55deaa75943cc348d40a2dcc.jpeg', title: '冬の静けさ' },
  { id: 20, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/4b3329e42e1492f0ab458cc75801b935.jpeg', title: '花畑の笑顔' },
  { id: 21, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/c9a40261c85e625aff9b1436e67f511e.jpeg', title: '夜の輝き' },
  { id: 22, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/632fa23e64a14c73b242118077e48ed2.jpeg', title: '優しい笑顔' },
  { id: 23, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/a9d9395e8b7e054de2c6da58876f7edb.jpeg', title: '森の中で' },
  { id: 24, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/7c03e78fa0ea53672b33e37fc4a7da4b.jpeg', title: '職人の眼差し' },
  { id: 25, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/0a308188d5142a5bd9c3e19d4c905ad3.jpeg', title: '空の上で' },
  { id: 26, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/dddbd457811e86d7545dcbc44f1d30ee.jpeg', title: 'ホワイトスタジオ' },
  { id: 27, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/d3a2e0bb96c38ec96f263f3b2af9eacb.jpeg', title: '神社の佇まい' },
  { id: 28, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/dfe24f044a97cc917fec7c6d01e4f8a0.jpeg', title: '川辺の夕暮れ' },
  { id: 29, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/9e9d3d35e2e3f928f89fea31b22d1cdb.jpeg', title: '本の世界' },
  { id: 30, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/1dd5cf2ba4e31720871955f3dd41fbc1.jpeg', title: '朝霧の中で' },
  // Page 3
  { id: 31, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/fdd60f4cb2e739a56941ef33eed62038.jpeg', title: '和室の光' },
  { id: 32, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/6252a9732b928cfd847edb8400c083fd.jpeg', title: '光と影' },
  { id: 33, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/37438a878c48531dbaab5fccc16ac8e1.jpeg', title: '花びらの中で' },
  { id: 34, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/928f1b503a372c2de461a5cfc00073db.jpeg', title: 'ヴィンテージの記憶' },
  { id: 35, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/19e96bd5217432e312ffe644cf7b49e7.jpeg', title: '建築と人' },
  { id: 36, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/8ba02b895316cd9e7703f202197d10a2.jpeg', title: '燭台の灯り' },
  { id: 37, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/acc040102a530139ebc169ca25dd2bb8.jpeg', title: '田園の風景' },
  { id: 38, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/aa178c2d8508b1deb36332654b34000d.jpeg', title: '音楽家の魂' },
  { id: 39, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/a0e6dea44c65f89bf38c008c5e102992.jpeg', title: '湖面の鏡' },
  { id: 40, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/4ca2fd96ecf3e463a753d5f7175d0c93.jpeg', title: '星空の下で' },
  { id: 41, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/bfac5e7267673a045d0dd30d6fbc70df.jpeg', title: '朝の光の中で' },
  { id: 42, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/f843a46debec3e906f9542e11d9cd73d.jpeg', title: '夏祭りの夜' },
  { id: 43, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/513185b3614ae0b809479b8bc3be5673.jpeg', title: '禅の庭で' },
  { id: 44, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/6ba09339c2ce101d0073c6373b4e499f.jpeg', title: '嵐の前に' },
  { id: 45, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/fce7af2a107e0731d09b17c0aa4915fa.jpeg', title: '春の温もり' },
];

function PortraitJsonLd() {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      '@id': `${SITE_URL}/portfolio/portrait#webpage`,
      url: `${SITE_URL}/portfolio/portrait`,
      name: 'Portrait Photography | KAZU.PHOTO – 石川県金沢市 ポートレートギャラリー',
      description: '石川県金沢市のフォトグラファーKAZU.PHOTOによるポートレートポートフォリオ。一人ひとりの個性と表情を丁寧に切り取った45枚以上の作品集。',
      inLanguage: 'ja',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
          { '@type': 'ListItem', position: 2, name: 'Portfolio', item: `${SITE_URL}/portfolio/portrait` },
          { '@type': 'ListItem', position: 3, name: 'Portrait', item: `${SITE_URL}/portfolio/portrait` },
        ],
      },
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'jsonld-portrait';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { script.parentNode?.removeChild(script); };
  }, []);
  return null;
}

export default function PortraitGallery() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(allPortraitPhotos.length / PHOTOS_PER_PAGE);
  const startIndex = (currentPage - 1) * PHOTOS_PER_PAGE;
  const currentPhotos = allPortraitPhotos.slice(startIndex, startIndex + PHOTOS_PER_PAGE);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openLightbox = (index: number) => {
    setSelectedImage(startIndex + index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction: 'prev' | 'next') => {
    if (selectedImage === null) return;
    if (direction === 'prev') {
      setSelectedImage(selectedImage === 0 ? allPortraitPhotos.length - 1 : selectedImage - 1);
    } else {
      setSelectedImage(selectedImage === allPortraitPhotos.length - 1 ? 0 : selectedImage + 1);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="bg-white min-h-screen">
      <PortraitJsonLd />
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
          scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-white'
        }`}
      >
        <div className="flex items-center justify-between px-8 lg:px-16 py-6">
          <Link
            to="/"
            className="text-xs tracking-[0.2em] font-light text-stone-900 hover:text-stone-600 transition-colors"
          >
            KAZU.PHOTO
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-xs tracking-[0.2em] font-light text-stone-600 hover:text-stone-900 transition-colors"
          >
            <i className="ri-arrow-left-line" />
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Header */}
      <section className="pt-32 pb-20 px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <span className="text-[10px] tracking-[0.3em] text-stone-400 uppercase mb-4 block">
            Portfolio
          </span>
          <h1 className="text-5xl md:text-6xl font-extralight tracking-wide text-stone-900 mb-4">
            Portrait
          </h1>
          <p className="text-sm text-stone-500 font-light tracking-wide">
            一人ひとりの個性を
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="pb-16 px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {currentPhotos.map((photo, index) => (
              <div
                key={photo.id}
                onClick={() => openLightbox(index)}
                className="group cursor-pointer relative overflow-hidden rounded-2xl bg-stone-100"
              >
                <div className="w-full flex items-center justify-center min-h-[300px] overflow-hidden">
                  <img
                    src={photo.url}
                    alt={photo.title}
                    className="w-full h-auto object-contain transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-search-line text-white text-3xl" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-center gap-6 mt-16 mb-4">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="w-10 h-10 flex items-center justify-center text-stone-400 hover:text-stone-900 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg" />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`w-10 h-10 flex items-center justify-center text-xs tracking-[0.2em] transition-all duration-300 cursor-pointer rounded-full ${
                  currentPage === page
                    ? 'bg-stone-900 text-white'
                    : 'text-stone-500 hover:text-stone-900 hover:bg-stone-100'
                }`}
              >
                {page}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="w-10 h-10 flex items-center justify-center text-stone-400 hover:text-stone-900 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-lg" />
            </button>
          </div>

          {/* Page indicator */}
          <p className="text-center text-[10px] tracking-[0.3em] text-stone-400 uppercase mb-16">
            {startIndex + 1} – {Math.min(startIndex + PHOTOS_PER_PAGE, allPortraitPhotos.length)} / {allPortraitPhotos.length} photos
          </p>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center text-white hover:text-stone-300 transition-colors z-10 cursor-pointer"
          >
            <i className="ri-close-line text-3xl" />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('prev');
            }}
            className="absolute left-6 w-12 h-12 flex items-center justify-center text-white hover:text-stone-300 transition-colors z-10 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-3xl" />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('next');
            }}
            className="absolute right-6 w-12 h-12 flex items-center justify-center text-white hover:text-stone-300 transition-colors z-10 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-3xl" />
          </button>

          <div
            className="max-w-6xl max-h-[90vh] px-16"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={allPortraitPhotos[selectedImage].url}
              alt={allPortraitPhotos[selectedImage].title}
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
            />
          </div>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-xs tracking-wider">
            {selectedImage + 1} / {allPortraitPhotos.length}
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-stone-900 text-white py-16 px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="text-2xl font-extralight tracking-wide mb-2">KAZU.PHOTO</h3>
              <p className="text-xs text-white/60 tracking-wider">
                Photographer / Videografer
              </p>
            </div>
            <Link
              to="/"
              className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Back to Home
            </Link>
          </div>
          <div className="pt-8 mt-8 border-t border-white/10 text-center">
            <p className="text-xs text-white/40">© 2025 KAZU.PHOTO</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
